import React from "react";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { Values } from "Tools/Values";
import PositionTableItem from "./PositionTableItem/PositionTableItem";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { Position } from "@src/Interfaces/Entity/Position";

interface IProps {
  positions: Position[];
  onEditButtonClick: (position: Position) => void;
}

export default class PositionsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("title")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.positions.map((position: Position) => (
                <PositionTableItem
                    onEditButtonClick={() => this.props.onEditButtonClick(position)}
                    key={position.id}
                    position={position}
                />
            ))}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
